import { ExternalLink } from '@fastnorth/kraken/components/navigation';
import { Text } from '@fastnorth/kraken/components/typography';
import { ExternalLinkIcon } from 'lucide-react';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

type RewardLinkProps = {
  url: string;
};

const RewardLink = ({ url }: RewardLinkProps): ReactElement => {
  const { t } = useTranslation('translation', { keyPrefix: 'karwa.event.race.result' });

  return (
    <ExternalLink href={url}>
      <Text>{t('reward')}</Text> <ExternalLinkIcon strokeWidth={2} size={16} className={'ml-3'} />
    </ExternalLink>
  );
};

export default RewardLink;
